import React, { Component } from 'react';
import { Typography, withStyles } from '@material-ui/core';
import { withRouter } from 'react-router-dom';

import Container from '../component/div/Container';
import ScrollPages from '../common/ScrollPages';
import { CONTAINER_HEIGHT } from '../common/Constants';

import './About.css';

const styles = (theme) => ({
  //Vision
  visionContainer: {
    position: 'relative',
    width: '100%',
    // height: '100%',
    height: 'calc(100vh - 85px)',
    background: `#fafafa url('images/background/about_web_bg1.png')`,
    backgroundBlendMode: 'multiply',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center right',
    [theme.breakpoints.down('sm')]: {
      '&:before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        width: '100%',
        height: `calc(${window.innerHeight}px - 135px)`,
        backgroundImage: `url('images/background/about_web_bg1.png')`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: '35% 100%',
        opacity: 0.5,
      },
      background: 'none',
    },
    '& > div': {
      width: '100%',
      height: '100%',
      padding: '7% 20%',
      [theme.breakpoints.down('sm')]: {
        position: 'relative',
        padding: '15% 10% 7%',
      },
    },
    '& span': {
      color: theme.palette.primary.main,
      fontWeight: 'bold',
    },
  },
  divisionLine: {
    width: '68px',
    height: '1px',
    backgroundColor: theme.palette.primary.main,
    margin: theme.spacing(3, 0, 4),
  },
  title: {
    color: '#595656',
    fontSize: '2.125rem',
    fontWeight: 400,
    lineHeight: 1.235,
    [theme.breakpoints.down('md')]: {
      fontSize: '1.8rem',
      // lineHeight: 1.334,
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.5rem',
      lineHeight: 1.334,
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.2rem',
      lineHeight: 1.3,
    },
  },
  content: {
    color: '#565656',
    '& p': {
      [theme.breakpoints.down('md')]: {
        fontSize: '0.85rem',
      },
      // [theme.breakpoints.down('sm')]: {
      //   fontSize: '0.85rem',
      // },
      [theme.breakpoints.down('xs')]: {
        fontSize: '0.8rem',
      },
    },
    '& p:first-child': {
      marginBottom: '1.5em',
    },
  },

  //Organization chart
  organizationContainer: {
    position: 'relative',
    width: '100%',
    height: '100%',
    background: `#fafafa url('images/background/about_web_bg2.png')`,
    backgroundSize: '100%',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    [theme.breakpoints.down('sm')]: {
      background: `#fafafa url('images/background/about_mobile_bg2.png')`,
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
    },
    '& > div': {
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: theme.spacing(15, 0),
      [theme.breakpoints.down('md')]: {
        padding: theme.spacing(8, 0),
      },
    },
  },
  chartWeb: {
    height: '90%',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  chartMobile: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      height: '100%',
    },
  },

  //scroll down&up button
  scrollButton: {
    textAlign: 'center',
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)',
    cursor: 'pointer',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  scrollDown: {
    bottom: '1rem',
  },
  scrollUp: {
    top: '2rem',
  },
});

let scrollInstance;

class About extends Component {
  constructor(props) {
    super(props);
    this.state = {
      path: this.props.location.pathname.split('/')[2],
    };

    this.refVision = React.createRef();
    this.refOrganization = React.createRef();
  }

  componentDidUpdate(props, state) {
    if (this.props.location.pathname.split('/')[2] !== state.path) {
      this.setState({ path: this.props.location.pathname.split('/')[2] }, () => {
        this.setInitialTop();
      });
    }
  }

  componentDidMount() {
    scrollInstance = null;
    scrollInstance = new ScrollPages(1, 2, document.getElementById('all-pages'), 'about');
    scrollInstance.init();
    this.setInitialTop();

    //TODO. 창 크기 변화에 따른 eventlistener 검색해보고 수정
    //window.innerHeight가 725px보다 작아지면 글자크기 줄일것

    this.refVision.current.style.height = `calc(${window.innerHeight}px - ${CONTAINER_HEIGHT}px)`;
    this.refOrganization.current.style.height = `calc(${window.innerHeight}px - ${CONTAINER_HEIGHT}px)`;

    window.addEventListener('resize', this.handleEvent);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleEvent);
    if (scrollInstance) {
      scrollInstance.remove();
    }
    scrollInstance = null;
  }

  handleEvent = () => {
    const divElem = document.getElementById('all-pages').firstElementChild.firstElementChild;
    const title = document.getElementById('vision-title');
    const content = document.getElementById('vision-content');

    this.refVision.current.style.height = `calc(${window.innerHeight}px - ${CONTAINER_HEIGHT}px)`;
    this.refOrganization.current.style.height = `calc(${window.innerHeight}px - ${CONTAINER_HEIGHT}px)`;

    // if (window.innerHeight < 725) {
    //   title.style.fontSize = '2rem';
    //   content.style.fontSize = '0.9rem';
    // }
    // if (window.innerHeight < 670) {
    //   title.style.fontSize = '1.9rem';
    // }
    // if (window.innerHeight < 600) {
    //   divElem.style.padding = '5% 20%';
    //   title.style.fontSize = '1.75rem';
    //   content.style.fontSize = '0.85rem';
    // }
  };

  setInitialTop() {
    let pages = document.getElementById('all-pages');
    let viewHeight = document.documentElement.clientHeight;
    let footer = document.getElementById('footer');

    if (this.state.path === 'organization') {
      pages.style.top = -viewHeight * 1 + CONTAINER_HEIGHT + 'px';
      sessionStorage.setItem('currentPage', 2);
    } else {
      pages.style.top = -viewHeight * 0 + 'px';
      sessionStorage.setItem('currentPage', 1);
    }
  }

  setScrollButtonTop(action) {
    let pages = document.getElementById('all-pages');
    let viewHeight = document.documentElement.clientHeight;
    let footer = document.getElementById('footer');

    if (action === 'down') {
      pages.style.top = -viewHeight * 1 + 135 + 'px';
      sessionStorage.setItem('currentPage', 2);
    } else {
      pages.style.top = -viewHeight * 0 + 'px';
      sessionStorage.setItem('currentPage', 1);
    }
  }

  render() {
    const { classes } = this.props;

    return (
      <Container currentPath={this.props.location.pathname}>
        <div className="fullscreen-container">
          <div id="all-pages" style={{ position: 'relative', top: 0 }}>
            <section className={classes.visionContainer} id={'vision-container'} ref={this.refVision}>
              <div>
                <div>
                  <Typography className={classes.title} id={'vision-title'}>
                    We create
                    <br />
                    unforgettable events
                    <br />
                    that leave a lasting
                    <br />
                    impression
                    <br />
                    on your guests.
                  </Typography>
                </div>
                <div className={classes.divisionLine} />
                <div className={classes.content} id={'vision-content'}>
                  <Typography>
                    (주)이노앤은 다년간
                    <br />
                    온·오프라인 마케팅, 광고, 홍보, 디자인, 제작
                    <br />
                    노하우와 인프라를 바탕으로
                    <br />
                    국내 제일의 BTL 마케팅 에이전시를 지향합니다.
                  </Typography>
                  <Typography>
                    비대면과 <span>On-tact Event Trend</span>를 선도하는
                    <br />
                    <span>Virtual Meeting, International Conference</span>를
                    <br />
                    맞춤형으로 기획 및 운영하고 있습니다.
                  </Typography>
                </div>
                <div className={`${classes.scrollButton} ${classes.scrollDown}`} onClick={() => this.setScrollButtonTop('down')}>
                  <img src="images/icon/scroll_down.png" alt="scroll_down" />
                </div>
              </div>
            </section>
            <section className={classes.organizationContainer} id={'organization-container'} ref={this.refOrganization}>
              <div>
                <img src="images/about/organization_chart.png" alt="organization_chart" className={classes.chartWeb} />
                <img src="images/about/organization_chart_mobile.png" alt="organization_chart_mobile" className={classes.chartMobile} />
                <div className={`${classes.scrollButton} ${classes.scrollUp}`} onClick={() => this.setScrollButtonTop('up')}>
                  <img src="images/icon/scroll_up.png" alt="scroll_up" />
                </div>
              </div>
            </section>
          </div>
        </div>
      </Container>
    );
  }
}

export default withRouter(withStyles(styles)(About));
